/* src/app/reports/company-report-generator/company-report-generator.component.css */
.gray {
  background-color: var(--gray);
}
.float-right {
  float: right;
}
.datetime-picker-label {
  font-size: 9pt;
  padding-left: 20px;
}
.datetime-picker {
  border: none;
  border-bottom: 1px solid black;
  padding-left: 20px;
}
.date-icon {
  padding-left: 10px;
}
/*# sourceMappingURL=company-report-generator.component.css.map */
